import React, {useState, useEffect, useRef } from 'react'
import './PracticePage.css'
import './PracticePageGuided.css'
import { Link, Navigate } from 'react-router-dom'
import Header from './Header'
import FooterPractice from './FooterPractice'
import DotSpinner from './Spinner'

import SorobanIcon from '@mui/icons-material/BlurLinearSharp'
import AnzanIcon from '@mui/icons-material/PsychologySharp'
import FlashIcon from '@mui/icons-material/BoltSharp'
import AudibleIcon from '@mui/icons-material/SpatialTrackingSharp'
import FactsIcon from '@mui/icons-material/CalculateSharp'
import CircleIcon from '@mui/icons-material/CircleSharp'
import VideoIcon from '@mui/icons-material/VideocamSharp'
import ToolsIcon from '@mui/icons-material/Construction'
import SumoFighterIcon from './SumoFighterIcon'
import DrawIcon from '@mui/icons-material/Draw'
import VideoChat from '@mui/icons-material/VoiceChat'
import JumpIcon from '@mui/icons-material/MoveDown'
import RestartGuided from '@mui/icons-material/RestartAlt'

import Environment from './env_var'
import ErrorHandling from './Error_Handling'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import SwitchLabel from '../../node_modules/@mui/material/FormControlLabel'
import Switch from '../../node_modules/@mui/material/Switch'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '../../node_modules/@mui/material/Button'
import Pagination from '@mui/material/Pagination'
import { StickyShareButtons } from 'sharethis-reactjs'
import YouTubePlayer from 'react-youtube'
import "../../node_modules/video-react/dist/video-react.css"

import Uppy from '@uppy/core';
import Webcam from '@uppy/webcam';
import XHR from '@uppy/xhr-upload';
import { Dashboard } from '@uppy/react';
import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.min.css';
import '@uppy/webcam/dist/style.min.css';


const PracticePageQuided = (props) => {

	const [data, setData] = useState(null)

	const [centerSumo, setCenterSumo] = useState(false)
	const sumoRef = useRef(null)
	const sumoIndexRef = useRef()
	const sumoActivityIndexRef = useRef()

	const [error, setError] = useState(false)
	const [errorCode, setErrorCode] = useState('')
	const [errorMessage, setErrorMessage] = useState('')
	const [redirectType, setRedirectType] = useState(null)
	const [redirectURL, setRedirectURL] = useState(null)

	const [isLoggedIn, setIsLoggedIn] = useState(false)
	const [justLoggedIn, setJustLoggedIn] = useState(false)

	const [platformName, setPlatformName] = useState('')
	const [deviceType, setDeviceType] = useState('')
	const [isFullScreen, setIsFullScreen] = useState(false)

	const [showOnBoarding, setShowOnBoarding] = useState(false)
	const [showPreGuidedVideo, setShowPreGuidedVideo] = useState(false)
	const [videoSource, setVideoSource] = useState(null)
	const [videoTitle, setVideoTitle] = useState('')
	const [videoLoadError, setVideoLoadError] = useState(false)

	const [sendEventData, setSendEventData] = useState(false)
	const [eventData, setEventData] = useState(null)

	const [showSocialSharingBar, setShowSocialSharingBar] = useState(true)
	const [showSocialSharingDialog, setShowSocialSharingDialog] = useState(false)
	const [settingData, setSettingData] = useState(null)
	
	const [urlRef, setUrlRef] = useState(null)
	const [windowWidth, setWindowWidth] = useState(null)
	const [windowHeight, setWindowHeight] = useState(null)

	//const [openSumoAction, setOpenSumoAction] = useState(false)
	const [openAction, setOpenAction] = useState(false)
	const unitDivRef = useRef([])
	const [currentAction, setCurrentAction] = useState(null)

	const [showTreasureChestVideo, setShowTreasureChestVideo] = useState(false)
	const [showVideoChat, setShowVideoChat] = useState(false)
	const [showKanjiVideo, setShowKanjiVideo] = useState(false)
	const [kanjiId, setKanjiId] = useState(null)
	const [kanjiMovie, setKanjiMovie] = useState(null)
	const [kanjiMeaning, setKanjiMeaning] = useState(null)
	const videoPlayer = useRef()
	const playVideo = () => videoPlayer.current.play()

	const [navigateUser, setNavigateUser] = useState(null)

	const fetchDomain = Environment.environment.env === 'production' ? Environment.environment.productionURL
	: Environment.environment.stagingURL


	const [showJumpDialog, setShowJumpDialog] = useState(false)
	const [unitNumber, setUnitNumber] = useState(null)
	const [jumpingForward, setJumpingForward] = useState(null)
	const [jumpNavigate, setJumpNavigate] = useState(false)
	
	const handleShowJumpDialog = (unitNumber, jumpingForward) => {
		setShowJumpDialog(true);
		setUnitNumber(unitNumber);
		setJumpingForward(jumpingForward);
	}
	const handleRemoveJumpDialog = () => {
		setShowJumpDialog(false)
	}
	const handleJump = () => {
		setShowJumpDialog(false)
		setJumpNavigate(true)
	}

	const [sumoGroupNumber, setSumoGroupNumber] = useState(null)

	
	//if this is a preguided user show preguided video
	//this check is only needed for existing users prior to launching the guided program
	//each preguided user will only be shown this video once and they will choose
	//guided or unguided launchpad as a default.
	useEffect(() => {
		if (data) {
			if (data.guidedPreferred === null) {
				//show preguided video
				setShowPreGuidedVideo(true)
				setVideoSource(data.existingUserGuideVideoLocation)
			}
		}
	},[data])

	//user selects guided launchpad
	//send server settings event to set guidedPreferred to true
	const handleClosePreferredGuided = () => {
		setShowPreGuidedVideo(false)
		//send setting event
		setSettingData({
			settingName: 'guidedPreferred',
			settingValue: true
		})
	}

	//user selects unguided launchpad
	//send server settings event to set guidedPreferred to false
	const handleClosePreferredUnguided = () => {
		setShowPreGuidedVideo(false)
		//send settings event
		setSettingData({
			settingName: 'guidedPreferred',
			settingValue: false
		})
	}
	
	const handleCloseOnBoarding = (e) => {
		e.stopPropagation()
		setShowOnBoarding(false)
		setCenterSumo(true)

		//send justRegistered event
		setEventData({
			eventName: 'justRegistered',
			eventData: {
				justRegistered: false
			}
		})
		setSendEventData(true)
	}
	
	const handleShowTreasureChestVideo = (source) => {
		setVideoSource(source)
		setShowTreasureChestVideo(true)
	}

	const handleRemoveTreasureChestVideo = () => {
		setShowTreasureChestVideo(false)
	}

	const handleShowVideoChat = () => {
		setShowVideoChat(true)
	}

	const handleRemoveVideoChat = () => {
		setShowVideoChat(false)
	}

	const uppy = new Uppy(
		{restrictions: {
		  maxFileSize: 45000000,
		}})
		.use(Webcam, {
		  modes: ['video-audio'],
		  preferredVideoMimeType: 'video/mp4',
		})
		.use(XHR, { 
		  endpoint: '/rlm/includes/uppy/uppy_uploader.php', //'../uppy_uploader.php',
		  bundle: true,
		  formData: true 
	});

	const handleShowKanjiVideo = (kanjiId, kanjiMovie, kanjiMeaning) => {
		setShowKanjiVideo(true)
		setKanjiId(kanjiId)
		setKanjiMovie(kanjiMovie)
		setKanjiMeaning(kanjiMeaning)
	}

	const handleRemoveKanjiVideo = () => {
		setShowKanjiVideo(false)
	}
	
	//toggle action div to run this activity
	const toggleAction = (id, e) => {
		if (e) {
			e.stopPropagation()
			if (id) {
				if (id === currentAction) {
					setOpenAction(false)
					setCurrentAction(null)
				} else {
					setOpenAction(true)
					setCurrentAction(id)
				}
			} else {
				setOpenAction(false)
				setCurrentAction(null)
			}
		} else {
			setOpenAction(true)
			setCurrentAction(id)
		}
	}



	useEffect(() => {
		document.addEventListener('click', (e) => toggleAction(null, e))

		return () => document.removeEventListener('click', (e) => toggleAction(null, e))
	},[])

	//window update function to determine css responsiveness based on device screen size
	const updateWindowDimensions = () => {
		let windowWidth = typeof window !== 'undefined' ? window.innerWidth : 0
		let windowHeight = typeof window !== 'undefined' ? window.innerHeight : 0

		setWindowWidth(windowWidth)
		setWindowHeight(windowHeight)
	}

	//set window dimensions on resize event
	useEffect(() => {
		window.addEventListener('resize', updateWindowDimensions)

		return () => window.removeEventListener('resize', updateWindowDimensions)
	})

	//get initial window dimensions
	useEffect(() => {
		updateWindowDimensions()
	},[])

	const onPlayerReady = (event) => {
		setVideoTitle(event.target.playerInfo.videoData.title)
	}

	const onPlayerStateChange = (event) => {
		if (event.data === 1) {
			setEventData({
				eventName: 'VideoStarted',
				eventData: {
					videoCurrentTime: Math.round(event.target.getCurrentTime()),
					videoDuration: event.target.getDuration(),
					videoId: event.target.playerInfo.videoData.video_id,
					videoName: event.target.playerInfo.videoData.title
				}
			})
			setSendEventData(true)
		} else if (event.data === 2) {
			const currentTime = event.target.getCurrentTime()
			const videoDuration = event.target.getDuration()
			setEventData({
				eventName: 'VideoPaused',
				eventData: {
					percentVideoViewed: Math.round(currentTime/videoDuration*100),
					videoId: event.target.playerInfo.videoData.video_id,
					videoName: event.target.playerInfo.videoData.title
				}
			})
			setSendEventData(true)
		} else if (event.data === 0) {
			setEventData({
				eventName: 'VideoComplete',
				eventData: {
					percentVideoViewed: 100,
					videoId: event.target.playerInfo.videoData.video_id,
					videoName: event.target.playerInfo.videoData.title
				}
			})
			setSendEventData(true)
		}
	}

	const handleStickyShareButtons = (e) => {
		//log the social button usage
		//send share urlref
		setEventData({
			eventName: 'social share button',
			eventData: {
				shareButtonName: e.target.alt,
				urlRef: urlRef
			}
		})
		setSendEventData(true)
	}

	const handleSocialSwitchChange = (e) => {
		setShowSocialSharingBar(prevBarSetting => !prevBarSetting)
		setSettingData({
			settingName: 'showShareThisBar',
			settingValue: e.target.checked
		})
	}

	//show sharing dialog from Sumo Menu
	const openSocialSharingDialog = () => {
		setShowSocialSharingDialog(true)
	}

	const handleShowSocialSharingDialog = () => {
		setShowSocialSharingDialog(false)
	}
	
	
	//send any setting data to server
	useEffect(() => {
		if (settingData) {
			const fetchData = JSON.stringify({
				lpath: null,
				setSetting: settingData,
				env: Environment.environment.env,
				username: Environment.environment.username,
				password: Environment.environment.password
			})
			const headers = {'Content-Type': 'application/json', 'credentials': 'include'}

			const fetchDomain = Environment.environment.env === 'production' ? Environment.environment.productionURL
			: Environment.environment.stagingURL

			const controller = new AbortController();

			const fetchUserData = async () => {
				try {
					const response = await fetch(`${fetchDomain}/rlm/mobile-apis/set_setting_api.php`, {method: 'POST', headers: headers, body: fetchData});
					
					const data = await response.json();

					if (data.httpResponse === 200 || data.httpResponse === 201) {
						//check to see if user set guidedPreferred false, i.e. unguided
						if (settingData.settingName === 'guidedPreferred' && settingData.settingValue === false) {
							setNavigateUser(true) //send user to unguided launchpad
						}
						setSettingData(null)
					} else {
						setError(true)
						setErrorCode(data.httpResponse)
						setErrorMessage(data.message)
						setRedirectURL(data.redirectURL)
						setRedirectType(data.redirectType)
					}
				} catch (error) {
					setError(true)
					setErrorCode(500)
					setErrorMessage(error)
				}
			}

			fetchUserData();

			return ()  => {
				controller.abort();
			}
		}
	}, [settingData])

	const handleErrorAcknowledge = () => {
		//send new version event to server
		setEventData({
			eventType: 'client update',
			eventName: 'loaded new version',
			eventData: {
				OSName: platformName,
				deviceType: deviceType,
				deviceWidth: windowWidth,
				deviceHeight: windowHeight,
				standAlone: isFullScreen,
				userAgent: window.navigator.userAgent,
				version: Environment.environment.version
			}
		})
		setSendEventData(true)
	}

	//get the device platform, type, and standalone
	useEffect(() => {
		let platformName = ''
		if (window.navigator.platform) {
			platformName = window.navigator.platform //catch all
            if (window.navigator.platform.indexOf('iPhone')!==-1) platformName='iPhone' //iPhone
			if (window.navigator.platform.indexOf('iPad')!==-1) platformName='iPad' //iPad
            if (window.navigator.platform.indexOf('Android')!==-1) platformName='Android'
			if (window.navigator.platform.indexOf('Linux')!==-1) platformName='Android' //Xiaomi Redme 9A, Samsung
            if (window.navigator.platform.indexOf('MacIntel')!==-1) platformName='MacOS' //mac desktop
			if (window.navigator.platform.indexOf('MacPPC')!==-1) platformName='MacOS'
			if (window.navigator.platform.indexOf('Mac68k')!==-1) platformName='MacOS'
            if (window.navigator.platform.indexOf('Windows')!==-1) platformName='Windows' //windows
			if (window.navigator.platform.indexOf('Win32')!==-1) platformName='Windows'
			if (window.navigator.platform.indexOf('WinCE')!==-1) platformName='Windows'
            
        } else if (window.navigator.userAgentData.platform) {
			platformName = window.navigator.userAgentData.platform //catch all
            if (window.navigator.userAgentData.platform.indexOf('iPhone')!==-1) platformName='iPhone' //iPhone
			if (window.navigator.userAgentData.platform.indexOf('iPad')!==-1) platformName='iPad' //iPad
            if (window.navigator.userAgentData.platform.indexOf('Android')!==-1) platformName='Android'
			if (window.navigator.userAgentData.platform.indexOf('Linux')!==-1) platformName='Android' //Xiaomi Redme 9A, Samsung
            if (window.navigator.userAgentData.platform.indexOf('MacIntel')!==-1) platformName='MacOS' //mac desktop
			if (window.navigator.userAgentData.platform.indexOf('MacPPC')!==-1) platformName='MacOS'
			if (window.navigator.userAgentData.platform.indexOf('Mac68k')!==-1) platformName='MacOS'
            if (window.navigator.userAgentData.platform.indexOf('Windows')!==-1) platformName='Windows'
			if (window.navigator.userAgentData.platform.indexOf('Win32')!==-1) platformName='Windows'
			if (window.navigator.userAgentData.platform.indexOf('WinCE')!==-1) platformName='Windows'
        }
		setPlatformName(platformName)

		//determine the user's device type
		if (platformName === 'iPhone') {
			setDeviceType('iPhone')
		} else if (platformName === 'iPad') {
			setDeviceType('iPad tablet')
		} else if (platformName === 'Android') {
			if (window.matchMedia('(orientation: portrait)').matches) {
				if (window.innerWidth < 480) {
					setDeviceType('Android phone')
				} else {
					setDeviceType('Android tablet')
				}
			} else {
				if (window.innerWidth < 992) {
					setDeviceType('Android phone')
				} else {
					setDeviceType('Android tablet')
				}
			}
		} else {
			setDeviceType(platformName+' desktop')
		}

		//check for launch from homescreen
		if (window.matchMedia('(display-mode: standalone)').matches) {
			setIsFullScreen(true)
		}

		//set the document title
		document.title = 'SumoMath Launchpad'
	},[])


	//get guided ui data for user's current level
	useEffect(() => {
		//fetch launchpad data
		const fetchData = JSON.stringify({
			env: Environment.environment.env,
			username: Environment.environment.username, 
			password: Environment.environment.password,
			version: Environment.environment.version,
			requestedLevel: ''
		})
		const headers = {
			'Content-Type': 'application/json',
			'credentials': 'include'
		}
		
		const fetchDomain = Environment.environment.env === 'production' ? Environment.environment.productionURL
		: Environment.environment.stagingURL
		
		const controller = new AbortController();

		const fetchUserData = async () => {
			try {
				const response = await fetch(`${fetchDomain}/rlm/mobile-apis/guided_launchpad.php`, {
					method: 'POST', 
					headers: headers, 
					body: fetchData
				});
	
				const data = await response.json();
	
				if (data.httpResponse === 200 || data.httpResponse === 201) {
					setData(data)
					setIsLoggedIn(true)
					setJustLoggedIn(data.justLoggedIn)
					setShowSocialSharingBar(data.showShareThisBar)
				} else {
					setError(true)
					setErrorCode(data.httpResponse)
					setErrorMessage(data.message)
					setRedirectURL(data.redirectURL)
					setRedirectType(data.redirectType)
				}	
			} catch (error) {
				setError(true)
				setErrorCode(500)
				setErrorMessage('Error: '+error)
			}
		}

		fetchUserData();

		return () => {
			controller.abort();
		}
	}, [])


	//function to toggle unit div content
	const handleShowUnitDiv = (index, e) => {
		e.stopPropagation();
		if (unitDivRef.current[index].className === 'guided-module-container display-off') {
			unitDivRef.current[index].className = 'guided-module-container';
		} else {
			unitDivRef.current[index].className = 'guided-module-container display-off';
		}
	}
	

	//check if just registered, or paid subscriber
	useEffect(() => {
		if (data) {
			//check if onboarding videos should be shown
			if (data.justRegistered === '1') {
				let justRegisteredVideo = ''
				if (platformName === 'iPhone') {
					justRegisteredVideo = data.iphoneInstallVideoLocation
				} else if (platformName === 'Android') {
					justRegisteredVideo = data.androidInstallVideoLocation
				} else {
					justRegisteredVideo = data.generalInstallVideoLocation
				}

				setShowOnBoarding(true)
				setVideoSource(justRegisteredVideo)
			} else {
				setCenterSumo(true)
			}
			
			//send login environment event data
			//if user just logged in
			if (justLoggedIn) {
				setEventData({
					eventType: 'login',
					eventName: 'login',
					eventData: {
						OSName: platformName,
						deviceType: deviceType,
						standAlone: isFullScreen,
						userAgent: window.navigator.userAgent
					}
				})
				setSendEventData(true)
				
				//set justloggedIn local state value to false
				//only send event one time
				setJustLoggedIn(false)
			}

			//if not a paid subscriber show ad
			if (data.isPaidSubscriber === 0) {
					//set up left and right skyscraper ads
					const fetchDomain = Environment.environment.env === 'production' ? Environment.environment.productionURL
					: Environment.environment.stagingURL
					document.getElementById('left-margin-ad').src = `${fetchDomain}${data.leftMarginAd}`
					document.getElementById('right-margin-ad').src = `${fetchDomain}${data.rightMarginAd}`
			} else {
				document.getElementById('left-margin-ad').style.display = 'none'
				document.getElementById('right-margin-ad').style.display = 'none'
			}
		}
	}, [data])
		

	//if there is event logging data send it
	useEffect(() => {
		if (sendEventData) {
			const fetchData = JSON.stringify({
				lpath: null,
				event: eventData,
				env: Environment.environment.env,
				username: Environment.environment.username,
				password: Environment.environment.password
			})
			const headers = {'Content-Type': 'application/json', 'credentials': 'include'}

			const fetchDomain = Environment.environment.env === 'production' ? Environment.environment.productionURL
			: Environment.environment.stagingURL

			const controller = new AbortController();

			const fetchEventData = async () => {
				try {
					const response = await fetch(`${fetchDomain}/rlm/mobile-apis/event_log_api.php`, 
					{
						method: 'POST', 
						headers: headers, 
						body: fetchData
					})

					const data = await response.json();

					if (data.httpResponse === 200 || data.httpResponse === 201) {
						setSendEventData(false)
						//if this was a version update event reload page
						if(eventData.eventType === 'client update') {
							window.location.reload()
						}
					} else {
						setError(true)
						setErrorCode(data.httpResponse)
						setErrorMessage(data.message)
						setRedirectURL(data.redirectURL)
						setRedirectType(data.redirectType)
					}

				} catch (error) {
					setError(true)
					setErrorCode(500)
					setErrorMessage(error)
				}
			}

			fetchEventData();

			return () => {
				controller.abort();
			}
		}
	},[sendEventData])


	//function to select the correct icon needed for each element in the working path
	const getIcon = (activityType, problemType) => {

		switch (activityType) {
			case 'soroban':
				return (
					<SorobanIcon
						id= 'soroban-icon'
						style={{
							width: '60%',
							height: '60%',
							color: 'black',
							opacity: '1.0',
							position: 'absolute',
							top: '20%',
							left: '20%',
						}}
					/>
				)
			case 'facts':
				return (
					<FactsIcon
						id= 'facts-icon'
						style={{
							width: '60%',
							height: '60%',
							color: 'black',
							opacity: '1.0',
							position: 'absolute',
							top: '20%',
							left: '20%'
						}}
					/>
				)
			case 'video':
				return (
					<VideoIcon
						id= 'video-icon'
						style={{
							width: '60%',
							height: '60%',
							color: 'black',
							opacity: '1.0',
							position: 'absolute',
							top: '20%',
							left: '20%'
						}}
					/>
				)
			case 'kanji':
				return (
					<DrawIcon
						id= 'draw-icon'
						style={{
							width: '60%',
							height: '60%',
							color: 'black',
							opacity: '1.0',
							position: 'absolute',
							top: '20%',
							left: '20%',
						}}
					/>
				)
			case 'mental':
				if (
					problemType === 'anzan' || 
					problemType === 'anzan addition' ||
					problemType === 'anzan multiplication' ||
					problemType === 'anzan division') {
					return (
						<AnzanIcon
							id= 'anzan-icon'
							style={{
								width: '60%',
								height: '60%',
								color: 'black',
								opacity: '1.0',
								position: 'absolute',
								top: '20%',
								left: '20%'
							}}
						/>
					)
				} else if (problemType === 'flash') {
					return (
						<FlashIcon
							id= 'flash-icon'
							style={{
								width: '60%',
								height: '60%',
								color: 'black',
								opacity: '1.0',
								position: 'absolute',
								top: '20%',
								left: '20%'
							}}
						/>
					)
				} else if (problemType === 'audible') {
					return (
						<AudibleIcon
							id= 'audible-icon'
							style={{
								width: '60%',
								height: '60%',
								color: 'black',
								opacity: '1.0',
								position: 'absolute',
								top: '20%',
								left: '20%'
							}}
						/>
					)
				}
				break
			case 'tools':
				return (
					<ToolsIcon
						id= 'tools-icon'
						style={{
							width: '60%',
							height: '60%',
							color: 'black',
							opacity: '1.0',
							position: 'absolute',
							top: '20%',
							left: '20%'
						}}
					/>
				)
			default:
				return null
		}
	}

	//scroll sumo icon to center after data loaded
	useEffect(() => {
		if (sumoRef.current !== null) {
			let sumoDiv = sumoRef.current;
			if (sumoDiv.scrollIntoView) { //sumoRef.current !== null
				sumoDiv.scrollIntoView({
					behavior: "smooth",
					block: "center",
					inline: "center",
				});
				//setCenteredSumo(true)
				setCenterSumo(false)

				//find the sumo icon and open the action dialog
				data.modules.map((module, index) => {
					return (module.activities.map((activity, activityIndex) => {
						//check if activity is the user's current working lpath
						//if so assign the sumo icon
						if (activity.length) { //check if there are multiple icons in the row
							if (data.workingLpath === activity['0'].lpath &&  //removed toString
								module.moduleName === data.workingUnit) {
								//set sumoGroupNumber
								setSumoGroupNumber(activity[0].activity_group);
								
								//open sumo icon action dialog
								//toggleAction(`${index}${activityIndex}`)
								toggleAction('sumoFighterIcon', null)
							}
						} else {
							if (data.workingLpath === activity.lpath &&  //removed toString
								module.moduleName === data.workingUnit) {
								//set sumoGroupNumber
								setSumoGroupNumber(activity.activity_group);
								
								//open sumo icon action dialog
								//toggleAction(`${index}${activityIndex}`)
								toggleAction('sumoFighterIcon', null)
							}
						}
						return null
					}))
				})
			}
		}
	}, [centerSumo, data, sumoRef]);
	

	const ActivityRow = (props) => {
		let activityIcon = null;
		let activityIconColor = null;
		let activityIconOpacity = null;
		let activityIconLocked = false;
		let activityArrLength = props.activity.length;
		let toggleElementID = props.foundSumoIcon ? 'sumoFighterIcon' : `${props.index}${props.activityIndex}`;
		
		//checking for Sumo Icon
		if (activityArrLength) {
			
			if (props.foundSumoIcon && parseInt(props.activity[0].steps) > parseInt(props.activity[0].status.stepsComplete)) {
				activityIcon = 
				<SumoFighterIcon
						propref={sumoRef}
						id= 'sumoFighterIcon'
						width= '60%'
						height= '60%'
						fill= {openAction && currentAction === toggleElementID ? 'black' : 'greenyellow'}
						opacity= '1.0'
						className='sumo-fighter-icon'
				/>
			} else {
				activityIcon = getIcon(
									props.activity['0'].activity, 
									props.activity['0'].problemType
								)
			}
		} else if (props.foundSumoIcon && parseInt(props.activity.steps) > parseInt(props.activity.status.stepsComplete)) {
			activityIcon = 
				<SumoFighterIcon
						propref={sumoRef}
						id= 'sumoFighterIcon'
						width= '60%'
						height= '60%'
						fill= {openAction && currentAction === toggleElementID ? 'black' : 'greenyellow'}
						opacity= '1.0'
						className='sumo-fighter-icon'
				/>
		} else {
			activityIcon = getIcon(
								props.activity.activity, 
								props.activity.problemType
							)
		}
		
		//determine the color of the icon
		//all icons downstream from the Sumo Icon are grey
		//except those tasks with completed steps

		//first check if icon is beyond the working unit
		if (props.index < parseInt(data.workingUnit.match(/\d+/g)[0])) {
			if (props.sumoIndex !== null && props.sumoIndex < props.activityIndex) {
				//set all icons within the working unit after the sumo icon grey
				//unless all activity steps are complete then set it blue
				//if the activity is in the sumo group set icon blue
				if (activityArrLength) {
					if (props.activity[0].activity_group === sumoGroupNumber && props.activity[0].activity_unit === parseInt(data.workingUnit.match(/\d+/g)[0])) {
						//check to see the activity has been completed, if so it should be blue
						//otherwise make it greenyellow
						if (parseInt(props.activity[0].steps) <= parseInt(props.activity[0].status.stepsComplete) ||
							parseInt(props.activity[0].status.isJumped) === 1
						) {
							//task complete
							activityIconColor = 'dodgerblue';
							activityIconOpacity = '1.0';
						} else {
							activityIconColor = 'greenyellow';
							activityIconOpacity = '1.0';
						}
					} else if (parseInt(props.activity[0].steps) <= parseInt(props.activity[0].status.stepsComplete) ||
								parseInt(props.activity[0].status.isJumped) === 1
						) {
						//task complete
						activityIconColor = 'dodgerblue';
						activityIconOpacity = '1.0';
					} else {
						//make all these icons grey
						activityIconColor = 'white';
						activityIconOpacity = '0.5';
						activityIconLocked = true;
					}
				} else {
					if (props.activity.activity_group === sumoGroupNumber && props.activity.activity_unit === parseInt(data.workingUnit.match(/\d+/g)[0])) {
						//check to see the activity has been completed, if so it should be blue
						//otherwise make it greenyellow
						if (parseInt(props.activity.steps) <= parseInt(props.activity.status.stepsComplete) ||
							parseInt(props.activity.status.isJumped) === 1
						) {
							//task complete
							activityIconColor = 'dodgerblue';
							activityIconOpacity = '1.0';
						} else {
							activityIconColor = 'greenyellow';
							activityIconOpacity = '1.0';
						}
					} else if (parseInt(props.activity.steps) <= parseInt(props.activity.status.stepsComplete) ||
							parseInt(props.activity.status.isJumped) === 1
						) {
						//task complete
						activityIconColor = 'dodgerblue';
						activityIconOpacity = '1.0';
					} else {
						//make all these icons grey
						activityIconColor = 'white';
						activityIconOpacity = '0.5';
						activityIconLocked = true;
					}
				}
			} else {
				//set all icons prior to the sumo icon blue since these tasks are complete
				if (activityArrLength) {
					//make all these icons dodgerblue
					activityIconColor = 'dodgerblue';
					activityIconOpacity = '1.0';
				} else {
					//make all these icons dodgerblue
					activityIconColor = 'dodgerblue';
					activityIconOpacity = '1.0';
				}
			}
		} else {
			//set all icons down stream from the working unit to grey
			//unless all steps are complete set the icon to blue
			//users can complete activities using the unguided UI as well
			if (activityArrLength) {
				if (parseInt(props.activity[0].steps) <= parseInt(props.activity[0].status.stepsComplete) ||
					parseInt(props.activity[0].status.isJumped) === 1
				) {
					//task complete
					activityIconColor = 'dodgerblue';
					activityIconOpacity = '1.0';
				} else {
					//make all these icons grey
					activityIconColor = 'white';
					activityIconOpacity = '0.5';
					activityIconLocked = true;
				}
			} else {
				if (parseInt(props.activity.steps) <= parseInt(props.activity.status.stepsComplete) ||
					parseInt(props.activity.status.isJumped) === 1
				) {
					//task complete
					activityIconColor = 'dodgerblue';
					activityIconOpacity = '1.0';
				} else {
					//make all these icons grey
					activityIconColor = 'white';
					activityIconOpacity = '0.5';
					activityIconLocked = true;
				}
			}
		}

		let videoHandler = false;
		let videoSource = null;
		let kanjiId = null;
		let kanjiMovie = null;
		let kanjiMeaning = null;
		//set handlers for motivational video and kanji video
		if (activityArrLength) {
			if (activityArrLength < 3) {
				if (props.activity['1'].activity === 'video') {
					videoHandler = true;
					videoSource = props.activity['1'].pathname
				} else {
					kanjiId = props.activity['1'].kanjiId;
					kanjiMovie = props.activity['1'].kanjiMov;
					kanjiMeaning = props.activity['1'].kanjiMeaning === 'null' ? null : props.activity['1'].kanjiMeaning.replace(/"/g, "");
				}
			} else {
				if (props.activity['2'].activity === 'video') {
					videoHandler = true;
					videoSource = props.activity['2'].pathname
				} else {
					kanjiId = props.activity['2'].kanjiId;
					kanjiMovie = props.activity['2'].kanjiMov;
					kanjiMeaning = props.activity['2'].kanjiMeaning === 'null' ? null : props.activity['2'].kanjiMeaning.replace(/"/g, "");
				}
			}
		} else {
			if (props.activity.activity === 'video') {
				videoHandler = true;
				videoSource = props.activity.pathname;
			}
		}

		
		
		let activityType = null
		const positionIndex = props.activityIndex%8
		switch (positionIndex) {
			//center position
			case 0:
			case 4:
				//check if a mental activity
				if (props.activity.activity === 'mental') {
					activityType = props.activity.problemType.replace(/(^|\s)[a-z]/g, c => c.toUpperCase())
				} else {
					activityType = props.activity.activity.replace(/(^|\s)[a-z]/g, c => c.toUpperCase())
				}
				
				return (
					
					<div>
					<div className='task-row'>
						<div className='empty-div'></div>
						<div className='empty-div'></div>
						<div 
							className='multiicon-container'
							onClick={
								props.activityIndex === data.modules[props.index].activities.length -1 ? 
								() => handleShowTreasureChestVideo(videoSource) : 
								(e) => toggleAction(e.currentTarget.id, e)
							}
							id={toggleElementID}
							style={{
								pointerEvents: activityIconLocked ? 'none' : 'auto'
							}}
						>
							<CircleIcon
								style={{
									width: '100%',
									height: '100%',
									stroke: props.foundSumoIcon ? 'greenyellow' : null,
									color: (openAction && currentAction === toggleElementID) ? 'greenyellow' : props.foundSumoIcon ? 'black' : activityIconColor,
									opacity: activityIconOpacity
								}}
							/>
							{activityIcon}
						</div>
						{(openAction && currentAction === toggleElementID) &&
						<div className={`action-open position-center ${props.activityIndex === 0 ? 'top':'not-top'}`}>
							<div className='action-title-container'>
								<p className='action-title'>{activityType}</p>
								<p className='action-title'>{props.activity.activity === 'mental' ? props.activity.name : videoHandler ? null:`${props.activity.name} ${props.activity.problemType.replace(/(^|\s)[a-z]/g, c => c.toUpperCase())}`}</p>
							</div>
							<p className='action-lesson'>{props.activity.status.stepsComplete === null ? 0 : props.activity.status.stepsComplete}/{props.activity.steps}</p>
							<div className='action-button-container'>
								<Link className='' 
									to={{
										pathname: props.activity.pathname,
									}}
									state={{
										lpath: props.activity.lpath,
										problemType: props.activity.problemType,
										buttonClicked: props.activity.pathname
									}}
								>
									<Button 
										//onClick={}
										sx={{
											width: '100%'
										}}
										color='primary'
										variant='contained' 
										size='large'>START
									</Button>
								</Link>
							</div>
						</div>}
						<div className='empty-div'></div>
						<div className='empty-div'></div>
					</div>
					</div>
				)
			case 1:
			case 3:
				//position right one
				//check if a mental activity
				if (props.activity.activity === 'mental') {
					activityType = props.activity.problemType.replace(/(^|\s)[a-z]/g, c => c.toUpperCase())
				} else {
					activityType = props.activity.activity.replace(/(^|\s)[a-z]/g, c => c.toUpperCase())
				}
				return (
					<div>
					<div className='task-row'>
						<div className='empty-div'></div>
						<div className='empty-div'></div>
						<div className='empty-div'></div>
						<div
							className='multiicon-container'
							onClick={props.activityIndex === data.modules[props.index].activities.length -1 ? () => handleShowTreasureChestVideo(videoSource) : (e) => toggleAction(e.currentTarget.id, e)}
							id={toggleElementID}
							style={{
								pointerEvents: activityIconLocked ? 'none' : 'auto'
							}}
						>
							<CircleIcon
								style={{
									width: '100%',
									height: '100%',
									stroke: props.foundSumoIcon ? 'greenyellow' : null,
									color: (openAction && currentAction === toggleElementID) ? 'greenyellow' : props.foundSumoIcon ? 'black' : activityIconColor,
									opacity: activityIconOpacity
								}}
							/>
							{activityIcon}
						</div>
						{(openAction && currentAction === toggleElementID) && 
						<div className='action-open position-right-one'>
							<div className='action-title-container'>
								<p className='action-title'>{activityType}</p>
								<p className='action-title'>{props.activity.activity === 'mental' ? props.activity.name : videoHandler ? null:`${props.activity.name} ${props.activity.problemType.replace(/(^|\s)[a-z]/g, c => c.toUpperCase())}`}</p>
							</div>
							<p className='action-lesson'>{props.activity.status.stepsComplete === null ? 0 : props.activity.status.stepsComplete}/{props.activity.steps}</p>
							<div className='action-button-container'>
								<Link className='' 
									to={{
										pathname: props.activity.pathname,
									}}
									state={{
										lpath: props.activity.lpath,
										problemType: props.activity.problemType,
										buttonClicked: props.activity.pathname
									}}
								>
									<Button 
										//onClick={}
										sx={{
											width: '100%'
										}}
										color='primary'
										variant='contained' 
										size='large'>START
									</Button>
								</Link>
							</div>
						</div>}
						<div className='empty-div'></div>
					</div>
					</div>
				)
			case 2:
				//position right two
				//determine where to read problem type
				if (activityArrLength) {
					//check if a mental activity
					if (props.activity['0'].activity === 'mental') {
						activityType = props.activity['0'].problemType.replace(/(^|\s)[a-z]/g, c => c.toUpperCase())
					} else {
						activityType = props.activity['0'].activity.replace(/(^|\s)[a-z]/g, c => c.toUpperCase())
					}
				}
				
				return (
					<div>
						<div className='task-row'>
						{activityArrLength && activityArrLength < 3 ? //must check if video is last icon
						<> 
							{/*handle either a motiviation video or kanji video*/}
							<div
								className='multiicon-container'
								onClick={videoHandler ? () => handleShowTreasureChestVideo(videoSource) : () => handleShowKanjiVideo(kanjiId, kanjiMovie, kanjiMeaning)}
								id={props.activity['1'].lpath}
								style={{
									pointerEvents: props.index >= parseInt(data.workingUnit.match(/\d+/g)[0]) || 
									(props.sumoIndex !== null && props.activity[0].activity_group !== sumoGroupNumber) ? 'none' : 'auto'
								}}
							>
								<CircleIcon
									style={{
										width: '100%',
										height: '100%',
										color: props.index >= parseInt(data.workingUnit.match(/\d+/g)[0]) || 
											(props.sumoIndex !== null && props.activity[0].activity_group !== sumoGroupNumber) ? 'white' : activityIconColor,
										opacity: props.index >= parseInt(data.workingUnit.match(/\d+/g)[0]) || 
											(props.sumoIndex !== null && props.activity[0].activity_group !== sumoGroupNumber) ? '0.5' : activityIconOpacity
									}}
								/> 
								{activityArrLength ? getIcon(
														props.activity['1'].activity, 
														props.activity['1'].problemType
													):null}
							</div>
							
							{/*handle the user chat/feedback video
							<div 
								className='multiicon-container'
								onClick= {handleShowVideoChat} //{(e) => toggleAction(e.currentTarget.id, e)}
								id={`videochat-1`}
								style={{
									pointerEvents: activityIconLocked ? 'none' : 'auto'
								}}
							>
								<CircleIcon
									style={{
										width: '100%',
										height: '100%',
										color: 'greenyellow', //(openAction && currentAction === props.activity['1'].lpath.toString()) ? 'greenyellow':activityIconColor,
										opacity: activityIconOpacity
									}}
								/>
								<VideoChat 
									style={{
										width: '60%',
										height: '60%',
										color: 'black',
										opacity: '1.0',
										position: 'absolute',
										top: '20%',
										left: '20%'
									}}
								/>
							</div>*/}
							<div className='empty-div multi-icon-two'></div>
							<div className='empty-div multi-icon-two'></div>
							<div className='empty-div multi-icon-two'></div>
						</>
						: activityArrLength ? 
						<>
							<div 
								className='multiicon-container'
								onClick={videoHandler ? () => handleShowTreasureChestVideo(videoSource) : () => handleShowKanjiVideo(kanjiId, kanjiMovie, kanjiMeaning)}
								id={props.activity.length ? props.activity['2'].lpath : props.activity.lpath}
								style={{
									pointerEvents: props.index >= parseInt(data.workingUnit.match(/\d+/g)[0]) || 
									(props.sumoIndex !== null && props.activity[0].activity_group !== sumoGroupNumber) ? 'none' : 'auto'
								}}
							>
								<CircleIcon
									style={{
										width: '100%',
										height: '100%',
										color: props.index >= parseInt(data.workingUnit.match(/\d+/g)[0]) || 
											(props.sumoIndex !== null && props.activity[0].activity_group !== sumoGroupNumber) ? 'white' : activityIconColor,
										opacity: props.index >= parseInt(data.workingUnit.match(/\d+/g)[0]) || 
											(props.sumoIndex !== null && props.activity[0].activity_group !== sumoGroupNumber) ? '0.5' : activityIconOpacity
									}}
								/>
								{activityArrLength ? getIcon(
														props.activity['2'].activity, 
														props.activity['2'].problemType
													):null}
							</div>
							
							<div
								className='multiicon-container'
								onClick={(e) => toggleAction(e.currentTarget.id, e)}
								id={toggleElementID+'-1'}
								style={{
									pointerEvents: props.index >= parseInt(data.workingUnit.match(/\d+/g)[0]) || 
									(props.sumoIndex !== null && props.activity[0].activity_group !== sumoGroupNumber) ? 'none' : 'auto'
								}}
							>
								<CircleIcon
									style={{
										width: '100%',
										height: '100%',
										color: props.index >= parseInt(data.workingUnit.match(/\d+/g)[0]) || 
											(props.sumoIndex !== null && props.activity[0].activity_group !== sumoGroupNumber) ? 'white' : 
											(openAction && currentAction === toggleElementID+'-1') ? 'greenyellow':activityIconColor,
										opacity: props.index >= parseInt(data.workingUnit.match(/\d+/g)[0]) || 
											(props.sumoIndex !== null && props.activity[0].activity_group !== sumoGroupNumber) ? '0.5' : activityIconOpacity
									}}
								/>
								{activityArrLength ? getIcon(
														props.activity['1'].activity, 
														props.activity['1'].problemType
													):null}
							</div>
							{(openAction && currentAction === toggleElementID+'-1') && 
							<div className='action-open position-left-one multi-icon-2'>
								<div className='action-title-container'>
								<p className='action-title'>{props.activity['1'].activity.replace(/^./, c => c.toUpperCase())}</p>
								<p className='action-title'>{props.activity[1].activity === 'mental' ? props.activity[1].name : `${props.activity[1].name} ${props.activity[1].problemType.replace(/(^|\s)[a-z]/g, c => c.toUpperCase())}`}</p>
							</div>
								<p className='action-lesson'>{`${props.activity['1'].status.stepsComplete === null ? 0 : props.activity['1'].status.stepsComplete}/${props.activity['1'].steps}`}</p>
								<div className='action-button-container'>
									<Link className='' 
										to={{
											pathname: props.activity['1'].pathname,
										}}
										state={{
											lpath: typeof props.activity[1].lpath === 'string' ?  props.activity[1].lpath.replace(/-\d+$/, '') : props.activity[1].lpath,
											problemType: props.activity['1'].problemType,
											buttonClicked: props.activity['1'].pathname
										}}
									>
										<Button 
											//onClick={}
											sx={{
												width: '100%'
											}}
											color='primary'
											variant='contained' 
											size='large'>START
										</Button>
									</Link>
								</div>
							</div>}
							<div className='empty-div multi-icon-three'></div>
							<div className='empty-div multi-icon-three'></div>
						</> : null}
						
						{activityArrLength ?
						<div 
							className='multiicon-container'
							onClick={(e) => toggleAction(e.currentTarget.id, e)}
							id={toggleElementID} //-0
							style={{
								pointerEvents: activityIconLocked ? 'none' : 'auto'
							}}
						>
							<CircleIcon
								style={{
									width: '100%',
									height: '100%',
									stroke: props.foundSumoIcon ? 'greenyellow' : null,
									color: (openAction && currentAction === toggleElementID) ? 'greenyellow' : props.foundSumoIcon ? 'black' : activityIconColor,
									opacity: activityIconOpacity
								}}
							/>
							{activityIcon}
						</div>
						:
						<div
							className='multiicon-container'
							onClick={videoHandler ? () => handleShowTreasureChestVideo(videoSource) : () => handleShowKanjiVideo(kanjiId, kanjiMovie, kanjiMeaning)}
							id={props.activity.lpath}
							style={{
								pointerEvents: activityIconLocked ? 'none' : 'auto'
							}}
						>
							<CircleIcon
								style={{
									width: '100%',
									height: '100%',
									stroke: props.foundSumoIcon ? 'greenyellow' : null,
									color: activityIconColor,
									opacity: activityIconOpacity
								}}
							/>
							{getIcon(
								props.activity.activity, 
								props.activity.problemType
							)}
						</div>}
						{(openAction && currentAction === toggleElementID) && //-0
						<div className={activityArrLength === 3 ? 'action-open position-right-two multi-icon-2':'action-open position-right-two'}>
							<div className='action-title-container'>
								<p className='action-title'>{activityType}</p>
								<p className='action-title'>{props.activity[0].activity === 'mental' ? props.activity[0].name : `${props.activity[0].name} ${props.activity[0].problemType.replace(/(^|\s)[a-z]/g, c => c.toUpperCase())}`}</p>
							</div>
							<p className='action-lesson'>{props.activity['0'].status.stepsComplete === null ? 0 : props.activity['0'].status.stepsComplete}/{props.activity['0'].steps}</p>
							<div className='action-button-container'>
								<Link className='' 
									to={{
										pathname: props.activity['0'].pathname,
									}}
									state={{
										lpath: props.activity['0'].lpath,
										problemType: props.activity['0'].problemType,
										buttonClicked: props.activity['0'].pathname
									}}
								>
									<Button 
										//onClick={}
										sx={{
											width: '100%'
										}}
										color='primary'
										variant='contained' 
										size='large'>START
									</Button>
								</Link>
							</div>
						</div>}
					</div>
					</div>
				)
			case 5:
			case 7:
				//position left one
				//check if a mental activity
				if (props.activity.activity === 'mental') {
					activityType = props.activity.problemType.replace(/(^|\s)[a-z]/g, c => c.toUpperCase())
				} else {
					activityType = props.activity.activity.replace(/(^|\s)[a-z]/g, c => c.toUpperCase())
				}
				return (
					<div>
					<div className='task-row'>
						<div className='empty-div'></div>
						<div 
							className='multiicon-container'
							onClick={props.activityIndex === data.modules[props.index].activities.length -1 ? () => handleShowTreasureChestVideo(videoSource) : (e) => toggleAction(e.currentTarget.id, e)}
							id={toggleElementID}
							style={{
								pointerEvents: activityIconLocked ? 'none' : 'auto'
							}}
						>
							<CircleIcon
								style={{
									width: '100%',
									height: '100%',
									stroke: props.foundSumoIcon ? 'greenyellow' : null,
									color: (openAction && currentAction === toggleElementID) ? 'greenyellow' : props.foundSumoIcon ? 'black' : activityIconColor,
									opacity: activityIconOpacity
								}}
							/>
							{activityIcon}
						</div>
						{(openAction && currentAction === toggleElementID) && 
						<div className='action-open position-left-one'>
							<div className='action-title-container'>
								<p className='action-title'>{activityType}</p>
								<p className='action-title'>{props.activity.activity === 'mental' ? props.activity.name : videoHandler ? null:`${props.activity.name} ${props.activity.problemType.replace(/(^|\s)[a-z]/g, c => c.toUpperCase())}`}</p>
							</div>
							<p className='action-lesson'>{props.activity.status.stepsComplete === null ? 0 : props.activity.status.stepsComplete}/{props.activity.steps}</p>
							<div className='action-button-container'>
								<Link className='' 
									to={{
										pathname: props.activity.pathname,
									}}
									state={{
										lpath: props.activity.lpath,
										problemType: props.activity.problemType,
										buttonClicked: props.activity.pathname
									}}
								>
									<Button 
										//onClick={}
										sx={{
											width: '100%'
										}}
										color='primary'
										variant='contained' 
										size='large'>START
									</Button>
								</Link>
							</div>		
						</div>}
						<div className='empty-div'></div>
						<div className='empty-div'></div>
						<div className='empty-div'></div>
					</div>
					</div>
				)
			case 6:
				//position left two

				//determine where to read problem type
				if (activityArrLength) {
					//check if a mental activity
					if (props.activity['0'].activity === 'mental') {
						activityType = props.activity['0'].problemType.replace(/(^|\s)[a-z]/g, c => c.toUpperCase())
					} else {
						activityType = props.activity['0'].activity.replace(/(^|\s)[a-z]/g, c => c.toUpperCase())
					}
				}
				
				return (
					<div key={props.activity[0].id}>
					<div className='task-row'>
						<div
							className='multiicon-container'
							onClick={(e) => toggleAction(e.currentTarget.id, e)}
							id={toggleElementID} //-0
							style={{
								pointerEvents: activityIconLocked ? 'none' : 'auto'
							}}
						>
							<CircleIcon
								style={{
									width: '100%',
									height: '100%',
									stroke: props.foundSumoIcon ? 'greenyellow' : null,
									color: (openAction && currentAction === toggleElementID) ? 'greenyellow' : props.foundSumoIcon ? 'black' : activityIconColor,
									opacity: activityIconOpacity
								}}
							/>
							{activityIcon}
						</div>
						{(openAction && currentAction === toggleElementID) && //-0
						<div className={activityArrLength === 3 ? 'action-open position-left-two multi-icon-6':'action-open position-left-two'}>
							<div className='action-title-container'>
								<p className='action-title'>{activityType}</p>
								<p className='action-title'>{props.activity[0].activity === 'mental' ? props.activity[0].name : `${props.activity[0].name} ${props.activity[0].problemType.replace(/(^|\s)[a-z]/g, c => c.toUpperCase())}`}</p>
							</div>
							<p className='action-lesson'>{props.activity['0'].status.stepsComplete === null ? 0 : props.activity['0'].status.stepsComplete}/{props.activity['0'].steps}</p>
							<div className='action-button-container'>
								<Link className='' 
									to={{
										pathname: props.activity['0'].pathname,
									}}
									state={{
										lpath: props.activity['0'].lpath,
										problemType: props.activity['0'].problemType,
										buttonClicked: props.activity['0'].pathname
									}}
								>
									<Button 
										//onClick={}
										sx={{
											width: '100%'
										}}
										color='primary'
										variant='contained' 
										size='large'>START
									</Button>
								</Link>
							</div>	
						</div>}
						{activityArrLength < 3 ?
						<>
							<div className='empty-div multi-icon-two'></div>
							<div className='empty-div multi-icon-two'></div>
							<div className='empty-div multi-icon-two'></div>
							<div
								className='multiicon-container'
								onClick={videoHandler ? () => handleShowTreasureChestVideo(videoSource) : () => handleShowKanjiVideo(kanjiId, kanjiMovie, kanjiMeaning)}
								id={props.activity['1'].lpath}
								style={{
									pointerEvents: props.index >= parseInt(data.workingUnit.match(/\d+/g)[0]) || 
									(props.sumoIndex !== null && props.activity[0].activity_group !== sumoGroupNumber) ? 'none' : 'auto'
								}}
							>
								<CircleIcon
									style={{
										width: '100%',
										height: '100%',
										color: props.index >= parseInt(data.workingUnit.match(/\d+/g)[0]) || 
											(props.sumoIndex !== null && props.activity[0].activity_group !== sumoGroupNumber) ? 'white' : activityIconColor,
										opacity: props.index >= parseInt(data.workingUnit.match(/\d+/g)[0]) || 
											(props.sumoIndex !== null && props.activity[0].activity_group !== sumoGroupNumber) ? '0.5' : activityIconOpacity
									}}
								/>
								{activityArrLength ? getIcon(
														props.activity['1'].activity, 
														props.activity['1'].problemType
													):null}
							</div>
						</>
						:
						<>
							<div className='empty-div multi-icon-three'></div>
							<div className='empty-div multi-icon-three'></div>
							<div
								className='multiicon-container'
								onClick={(e) => toggleAction(e.currentTarget.id, e)}
								id={toggleElementID+'-1'}
								style={{
									pointerEvents: props.index >= parseInt(data.workingUnit.match(/\d+/g)[0]) || 
									(props.sumoIndex !== null && props.activity[0].activity_group !== sumoGroupNumber) ? 'none' : 'auto'
								}}
							>
								<CircleIcon
									style={{
										width: '100%',
										height: '100%',
										color: props.index >= parseInt(data.workingUnit.match(/\d+/g)[0]) || 
											(props.sumoIndex !== null && props.activity[0].activity_group !== sumoGroupNumber) ? 'white' : 
											(openAction && currentAction === toggleElementID+'-1') ? 'greenyellow':activityIconColor,
										opacity: props.index >= parseInt(data.workingUnit.match(/\d+/g)[0]) || 
											(props.sumoIndex !== null && props.activity[0].activity_group !== sumoGroupNumber) ? '0.5' : activityIconOpacity
									}}
								/>
								{activityArrLength ? getIcon(
														props.activity['1'].activity, 
														props.activity['1'].problemType
													):null}
							</div>
							
							<div
								className='multiicon-container'
								onClick={videoHandler ? () => handleShowTreasureChestVideo(videoSource) : () => handleShowKanjiVideo(kanjiId, kanjiMovie, kanjiMeaning)}
								id={props.activity['2'].activity.lpath}
								style={{
									pointerEvents: props.index >= parseInt(data.workingUnit.match(/\d+/g)[0]) || 
									(props.sumoIndex !== null && props.activity[0].activity_group !== sumoGroupNumber) ? 'none' : 'auto'
								}}
							>
								<CircleIcon
									style={{
										width: '100%',
										height: '100%',
										color: props.index >= parseInt(data.workingUnit.match(/\d+/g)[0]) || 
											(props.sumoIndex !== null && props.activity[0].activity_group !== sumoGroupNumber) ? 'white' :activityIconColor,
										opacity: props.index >= parseInt(data.workingUnit.match(/\d+/g)[0]) || 
											(props.sumoIndex !== null && props.activity[0].activity_group !== sumoGroupNumber) ? '0.5' : activityIconOpacity
									}}
								/>
								{activityArrLength ? getIcon(
														props.activity['2'].activity, 
														props.activity['2'].problemType
													):null}
							</div>
							{(openAction && currentAction === toggleElementID+'-1') && 
							<div className='action-open position-right-one multi-icon-6'>
								<div className='action-title-container'>
									<p className='action-title'>{props.activity[1].activity.replace(/(^|\s)[a-z]/g, c => c.toUpperCase())}</p>
									<p className='action-title'>{props.activity[1].activity === 'mental' ? props.activity[1].name : `${props.activity[1].name} ${props.activity[1].problemType.replace(/(^|\s)[a-z]/g, c => c.toUpperCase())}`}</p>
								</div>
								<p className='action-lesson'>{`${props.activity['1'].status.stepsComplete === null ? 0 : props.activity['1'].status.stepsComplete}/${props.activity['1'].steps}`}</p>
								<div className='action-button-container'>
									<Link className='' 
										to={{
											pathname: props.activity['1'].pathname,
										}}
										state={{
											lpath: typeof props.activity[1].lpath === 'string' ?  props.activity[1].lpath.replace(/-\d+$/, '') : props.activity[1].lpath,
											problemType: props.activity['1'].problemType,
											buttonClicked: props.activity['1'].pathname
										}}
									>
										<Button 
											//onClick={}
											sx={{
												width: '100%'
											}}
											color='primary'
											variant='contained' 
											size='large'>START
										</Button>
									</Link>
								</div>	
							</div>}
						</>}
					</div>
					</div>
				)
			default:
				return(<div></div>)
		}
	}

		
	if (data && !error) {
		const videoOpts = {
			height: '300',
			width: '400',
			playerVars: {
				frameBorder: '0',
				allow: 'fullscreen'
			}
		}
		
		//return modules 
		return (<React.Fragment>
					{navigateUser && //navigate user to unguided launchpad
					<Navigate 
						to={{
							pathname: '/launchpad',
						}}
						state={{
							isLoggedIn: true
						}}
					/>} 
					{jumpNavigate && //navigate user to jump page
					<Navigate 
						to={{
							pathname: '/launchpad-guided/testout'
						}}
						state={{
							unit: unitNumber,
							jumpingForward: jumpingForward
						}}
					/>}

					<>
					<Header showSocialSharingDialog={openSocialSharingDialog} isLoggedIn={isLoggedIn} />
					
					<div className={showOnBoarding ? 'hide-practice-page-guided-container':'practice-page-guided-container'}>
						{showSocialSharingBar && 
						<div className='share-this-bar-container' onClick={handleStickyShareButtons}>
						<StickyShareButtons
							config={{
								alignment: 'left',    // alignment of buttons (left, right)
								color: 'social',      // set the color of buttons (social, white) #87CEFA
								enabled: true, 	  // show/hide buttons (true, false)
								font_size: 16,        // font size for the buttons
								hide_desktop: true,  // hide buttons on desktop (true, false)
								labels: 'counts',     // button labels (cta, counts, null)
								language: 'en',       // which language to use (see LANGUAGES)
								min_count: 0,         // hide react counts less than min_count (INTEGER)
								networks: [           // which networks to include (see SHARING NETWORKS)
								'snapchat',
								'facebook',
								'twitter',
								'sms',
								'email'
								],
								padding: 7,          // padding within buttons (INTEGER)
								radius: 4,            // the corner radius on each button (INTEGER)
								show_total: false,     // show/hide the total share count (true, false)
								show_mobile: true,    // show/hide the buttons on mobile (true, false)
								show_toggle: false,    // show/hide the toggle buttons (true, false)
								size: 30,             // the size of each button (INTEGER)
								top: 0,             // offset in pixels from the top of the page
					
								// OPTIONAL PARAMETERS
								url: `${data.shareThis.url}`, // (defaults to current url)
								image: `${data.shareThis.image}`,  // (defaults to og:image or twitter:image)
								description: `${data.shareThis.description}`, // (defaults to og:description or twitter:description)
								title: `${data.shareThis.title}`, // (defaults to og:title or twitter:title)
								message: `${data.shareThis.message} ${data.shareThis.url}`, // (only for email sharing)
								subject: `${data.shareThis.subject}`, // (only for email sharing)
							}}
						/>
						</div>}
						
						{data.modules.map((module, index) => {
							const workingUnit = parseInt(data.workingUnit.match(/\d+/g)[0]);
							let foundSumoIcon = false;
							let sumoIndex = null;
							return (
								<div
									key={module.moduleName}
									className='unit-container'
								>
									<div 
										className='guided-module-header-container'
										onClick={(e) => handleShowUnitDiv(index, e)}	
									>
										<div className='unit-header-container'>
											<p 
												className='unit-number'
											>
												{module.moduleName}
											</p>
											{index === 0 ? 
											<div 
												className='jump-icon'
												onClick={() => handleShowJumpDialog(index+1, false)}
											>
												<RestartGuided 
													style={{
														width: '100%',
														height: '100%',
														fill: 'yellow',
														opacity: '1.0',
														margin: '5% auto'
													}}
												/>
											</div>
											: null}
											{/*Determine if the jump icon should be shown*/}
											{index > 0 && index < 11 ?
											<div
												className='jump-icon'
												onClick={() => handleShowJumpDialog(index+1, workingUnit < index+1 ? true:false )}
											>
												<JumpIcon 
													style={{
														width: '100%',
														height: '100%',
														fill: 'dodgerblue',
														opacity: '1.0',
														margin: '5% auto'
													}}
												/>
											</div>:null}
										</div>
										<p className='module-description'>{module.description}</p>
									</div>
									<div 
										ref={(e) => unitDivRef.current[index] = e}
										className={index === parseInt(data.workingUnit.match(/\d+/g)[0]) - 1 ? 'guided-module-container' : 'guided-module-container display-off'}
										id={module.moduleName.replace(/\s/, '')}
									>
										
										{module.activities.map((activity, activityIndex) => {
											//check if activity is the user's current working lpath
											//if so assign the sumo icon
											if (activity.length) { //check if there are multiple icons in the row
												if (data.workingLpath === activity['0'].lpath) {
													foundSumoIcon = true;
													sumoIndex = activityIndex;
													sumoActivityIndexRef.current = activityIndex
													sumoIndexRef.current = index
												} else {
													foundSumoIcon = false;
												}
											} else {
												if (data.workingLpath === activity.lpath) {
													foundSumoIcon = true;
													sumoIndex = activityIndex;
													sumoActivityIndexRef.current = activityIndex
													sumoIndexRef.current = index
												} else {
													foundSumoIcon = false;
												}
											}
											
											return (
												<ActivityRow 
													key={`${module.moduleName}${activityIndex}`} 
													activity={activity} 
													activityIndex={activityIndex}
													index={index} 
													foundSumoIcon={foundSumoIcon}
													sumoIndex={sumoIndex}
												/>
											)
										})}
										
									</div>
								</div>
							)
						})}
						
					</div>
					
					{/* show the jump dialog */}
					<Dialog 
                        open={showJumpDialog}
						PaperProps={{
							style: {
								width: '95%',
								height: 'auto',
								margin: '0'
							},
						}}
                    >
						<DialogContent>
						<div className='video-container-chat'>
							<p className='video-chat-header-text'>
								{jumpingForward ? `Jump to Unit ${unitNumber}?` : `Reset Program?`}
							</p>
							<p className='video-chat-text-question jump-text'>
								{jumpingForward ? 'You will need to pass 1 or more jump quizzes.' : `Do you want to reset the program to unit ${unitNumber}? Your data history will not be lost.`}
							</p>
						</div>
						</DialogContent>
                        <DialogActions>
							<Button 
                                onClick={handleJump} 
                                variant='outlined'
                                color='secondary'
                                size='large'>
                            {jumpingForward ? 'JUMP':'RESET'}
                            </Button>
							<Button 
                                onClick={handleRemoveJumpDialog} 
                                variant='outlined'
                                color='secondary'
                                size='large'>
                            CANCEL
                            </Button>
                        </DialogActions>
                    </Dialog>


					{/* show the user's motivational video */}
					<Dialog 
                        open={showTreasureChestVideo}
						PaperProps={{
							style: {
								width: '80%',
								height: 'auto',
								margin: '0'
							},
						}}
                    >
						<DialogContent>
						<div className='video-container-treasure'>
							{videoLoadError ?
							<>
							<p className='install-text'>
								We had some trouble loading the requested video on your device.
							</p>
							<p className='install-text'>
								Please check if your device is restricting YouTube videos and try again.
							</p>
							</>
							:
							<>
							<div className="training-video" >
								<video 
									className='treasure-video'
									id='html5Video'
									ref={videoPlayer}
									controls
									poster=''
									autoPlay='autoplay'
									playsInline={true}
									preload='auto'
									onClick={playVideo}
								>
									<source src={`${fetchDomain}${videoSource}`}
									type="video/webm" />
									<source src={`${fetchDomain}${videoSource}`}
									type="video/mp4" />
								</video>
							</div>
							</>}
						</div>
						</DialogContent>
                        <DialogActions>
                            <Button 
                                onClick={handleRemoveTreasureChestVideo} 
                                variant='outlined'
                                color='secondary'
                                size='large'>
                            DONE
                            </Button>
                        </DialogActions>
                    </Dialog>

					{/* show the video chat */}
					<Dialog 
                        open={showVideoChat}
						PaperProps={{
							style: {
								width: '95%',
								height: 'auto',
								margin: '0'
							},
						}}
                    >
						<DialogContent>
						<div className='video-container-chat'>
							<p className='video-chat-header-text'>
								Join the conversation!
							</p>
							<p className='video-chat-text-question'>
								What do you like about SumoMath?
							</p>
							<Dashboard className='uppy-video-chat-container' uppy={uppy} plugins={['Webcam']} disableLocalFiles={true} />
						</div>
						</DialogContent>
                        <DialogActions>
                            <Button 
                                onClick={handleRemoveVideoChat} 
                                variant='outlined'
                                color='secondary'
                                size='large'>
                            DONE
                            </Button>
                        </DialogActions>
                    </Dialog>

					{/* show the kanji video */}
					<Dialog 
                        open={showKanjiVideo}
						PaperProps={{
							style: {
								width: '80%',
								height: 'auto',
								margin: '0'
							},
						}}
                    >
						<DialogContent>
						<div className='kanji-video-container-guided'>
							<p className='kanji-meaning-guided'>{kanjiMeaning}</p>
							<video 
								className='kanji-video-guided'
								id='html5Video'
								ref={videoPlayer}
								poster=''
								autoPlay='autoplay'
								playsInline={true}
								preload='auto'
								onClick={playVideo}
							>
								<source src={`${fetchDomain}/kanji/kanji-library/${kanjiMovie}`}
								type="video/mp4" />
							</video>
						</div>
						</DialogContent>
                        <DialogActions>
							<Link
								className='kanji-draw-button-link'
								to={{
									pathname: '/launchpad/rewards/mykanji/mykanjidetail/drawkanji',
								}}
								state={{
									kanjiId: kanjiId
								}}
							>
								<Button 
									className='kanji-draw-button'
									variant='outlined'
									color='secondary'
									size='large'>
								Draw
								</Button>
							</Link>
							<Button 
                                onClick={handleRemoveKanjiVideo} 
                                variant='outlined'
                                color='secondary'
                                size='large'>
                            DONE
                            </Button>
                        </DialogActions>
                    </Dialog>
					
					{/* show the on boarding welcome video */}
					<Dialog
						open={showOnBoarding}
						className='mui-sumo-ad'
						PaperProps={{
							style: {
								width: `100%`,
								height: `${window.innerHeight}`,
								margin: '0'
							},
						}}
					>
						
						<DialogContent>
							<div className='video-container-guided'>
								<p className='video-welcome-text'>Thank you, please watch our welcome video.</p>
								<div className="training-video-guided" >
									<YouTubePlayer 
										videoId={videoSource}
										id='videoPlayerYT'
										opts={videoOpts}
										onStateChange={onPlayerStateChange}
										onReady={onPlayerReady}
									/>
								</div>
								<p className='video-footer-title-welcome'>{videoTitle}</p>
							</div>
							<Pagination className='pagination-guided' 
								count={1} 
								page={1}
							/>
						</DialogContent>
						<DialogActions>
							<Button 
                                onClick={handleCloseOnBoarding} 
                                variant='outlined'
                                color='secondary'
                                size='large'
							>DONE
                            </Button>
						</DialogActions>
						<p className='videohelp-message'>Tap the video icon to see all help videos.</p>
					</Dialog>


					{/* show the preguided video */}
					<Dialog
						open={showPreGuidedVideo}
						className='mui-sumo-ad'
						PaperProps={{
							style: {
								width: `100%`,
								height: `${window.innerHeight}`,
								margin: '0'
							},
						}}
					>
						
						<DialogContent>
							<div className='video-container-guided'>
								<p className='video-welcome-text'>You don't have to work independently.
								Try our new guided program!</p>
								<div className="training-video-guided" >
									<YouTubePlayer 
										videoId={videoSource}
										id='videoPlayerYT'
										opts={videoOpts}
										onStateChange={onPlayerStateChange}
										onReady={onPlayerReady}
									/>
								</div>
								<p className='video-footer-title-welcome'>{videoTitle}</p>
							</div>
							<Pagination className='pagination-guided' 
								count={1} 
								page={1}
							/>
							<p className='videohelp-message'>Please select your preferred default launchpad. Use settings in the Sumo menu to 
							change anytime.</p>
						</DialogContent>
						<DialogActions>
							<Button 
                                onClick={handleClosePreferredUnguided} 
                                variant='outlined'
                                color='secondary'
                                size='large'
							>UNGUIDED
                            </Button>
							<Button 
                                onClick={handleClosePreferredGuided} 
                                variant='outlined'
                                color='secondary'
                                size='large'
							>GUIDED
                            </Button>
						</DialogActions>
					</Dialog>

					
					{/* show the social sharing dialog */}
					<Dialog
						open={showSocialSharingDialog}
					>
						<div className='no-pointer-events'>
						<StickyShareButtons
							config={{
								alignment: 'left',    // alignment of buttons (left, right)
								color: 'social',      // set the color of buttons (social, white) #87CEFA
								enabled: true, 	  // show/hide buttons (true, false)
								font_size: 16,        // font size for the buttons
								hide_desktop: true,  // hide buttons on desktop (true, false)
								labels: 'counts',     // button labels (cta, counts, null)
								language: 'en',       // which language to use (see LANGUAGES)
								min_count: 0,         // hide react counts less than min_count (INTEGER)
								networks: [           // which networks to include (see SHARING NETWORKS)
								'snapchat',
								'facebook',
								'twitter',
								'sms',
								'email'
								],
								padding: 7,          // padding within buttons (INTEGER)
								radius: 4,            // the corner radius on each button (INTEGER)
								show_total: false,     // show/hide the total share count (true, false)
								show_mobile: true,    // show/hide the buttons on mobile (true, false)
								show_toggle: false,    // show/hide the toggle buttons (true, false)
								size: 30,             // the size of each button (INTEGER)
								top: 0,             // offset in pixels from the top of the page
							}}
						/>
						</div>
						<DialogTitle>Social Sharing Bar</DialogTitle>
						<SwitchLabel
							control={
							<Switch className='timer-switch'
								checked={showSocialSharingBar}
								onChange={handleSocialSwitchChange}
								name="socialSwitch"
								color="primary"
							/>
							}
							label='Social Sharing Bar'
						/>
						<DialogContent>
							<DialogContentText>
								Setting to show or hide the social sharing bar.
							</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Button onClick={handleShowSocialSharingDialog} variant='outlined' color='secondary' size='large'>OK</Button>
						</DialogActions>
					</Dialog>
					<FooterPractice view='launchpad' />
					</>
				</React.Fragment>)
	} else if (error) {

		return(
			<React.Fragment>
				<Header isLoggedIn={isLoggedIn} />
				<ErrorHandling
					error={error} 
					errorCode={errorCode} 
					errorMessage={errorMessage}
					redirectType={redirectType}
					redirectURL={redirectURL}
					requestingLogin={false}
					handleErrorAcknowledge={handleErrorAcknowledge}
				/>
				<FooterPractice view='launchpad' />
			</React.Fragment>
		)
	} else {
		return (
			<React.Fragment>
				<Header isLoggedIn={isLoggedIn} />
					<DotSpinner />
				<FooterPractice view='launchpad' />
			</React.Fragment>
		)
	}
}

export default PracticePageQuided
